export default __webpack_public_path__ + "static/media/mark.cad7faa1.jpg";